import { action, observable, makeObservable } from "mobx";
import { IClientDeviceDetected } from "./client-device.detected.interface";

export class ClientDeviceDetected implements IClientDeviceDetected {
    @observable
    public clientHintsAvailable = false;
    @observable
    public model = "";
    @observable
    public architecture = "";

    // this is sync data, no need to be observable, it's available from the begining
    @observable
    public platform = "";
    @observable
    public platformVersion = "";
    @observable
    public bitness = "";

    // this is sync data, no need to be observable, it's available from the begining
    @observable
    public mobile = undefined;

    // this is sync data, no need to be observable, it's available from the begining
    @observable
    public brands = [];
    @observable
    public uaFullVersion = "";

    constructor() {
        makeObservable(this);

        this.buildInfo();
    }

    private get navigator() {
        return (window.navigator as any);
    }

    @action.bound
    private buildInfo() {
        if (this.navigator.userAgentData) {
            this.clientHintsAvailable = true;
            this.platform = this.navigator.userAgentData.platform;
            this.mobile = this.navigator.userAgentData.mobile;
            this.brands = this.navigator.userAgentData.brands;
            /* https://developer.mozilla.org/en-US/docs/Web/API/NavigatorUAData/getHighEntropyValues */
            this.navigator.userAgentData.getHighEntropyValues([
                "model", "architecture", "platform", "platformVersion", "bitness", "uaFullVersion"
            ]).then(this.setAsyncdData);
        }
    }

    @action.bound
    private setAsyncdData = (data) => {
        this.platform = data.platform;
        this.platformVersion = data.platformVersion;
        this.mobile = data.mobile;

        this.model = data.model;
        this.uaFullVersion = data.uaFullVersion;
        this.architecture = data.architecture;
        this.bitness = data.bitness;
    };

}
